import Instruction from "./Instruction";

/**
 * An option in a Select, will a value that will be set in the variable if selected and a label.
 *
 * With the complex mode the label can be multi-line and even html.
 *
 * label can be resolve at runtime.
 */
class SelectOption extends Instruction
{
	constructor(value, label)
	{
		super();

		this.value = value;
		this.label = label;
		this.class = [];
		this.complex = false;
		this.href = false;
	}
	addClass(newClass)
	{
		this.class.push(newClass);

		return this;
	}
	isComplex()
	{
		this.complex = true;

		return this;
	}
	resolve(variables)
	{
		super.resolve(variables);
		this.label = Instruction._resolveValue(this.label, variables);
	}
	hasHref(url)
	{
		this.href = url;

		return this;
	}
}

export default SelectOption
